export default "__VITE_ASSET__CGI$C2vc__"